import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { CtaButtonComponent } from '../cta-button/cta-button.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-web-supervision',
  imports: [SectionWrapperComponent, MatIconModule, CtaButtonComponent],
  templateUrl: './web-supervision.component.html',
  styleUrl: './web-supervision.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebSupervisionComponent {
  private readonly siteConfig = inject(SiteConfigService);
  private readonly featureFlags = inject(FeatureFlagService);

  readonly section = computed(() => {
    this.featureFlags.flags();
    const data = this.siteConfig.webSupervision();
    if (!data) {
      return null;
    }
    return { ...data, items: this.featureFlags.filterItems(data.items) };
  });
}
